import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { NgForm } from '@angular/forms';
import { ConfirmPurchaseResponse1, DBInsertProps, GenerateUWDocumentResponse, GetALLCoveragesDetailResponse, GetCountryDetailbyAreaRequest, GetCountryDetailbyAreaResponse, GetCoveragesDetailbyAreaRequest, GetCoveragesDetailByAreaResponse, GetPackagesDetailByTravelPeriodWithCovidResponse, GetRequestedUWDocumentDataResponse, InsuranceIssuanceBaseData, InsuranceRights, ProcessUWRequestDataResponse, PurchaseResponse, RootResponse, TravelInsuranceDataProps, TravelInsurancePlanPurchaseProperties, UnitedPassengersBaseProperties } from '../Models/TravelInsuranceProperties';
import { EmailItineraryProperties } from '../Models/ERPProperties';
import { error } from 'console';
import { ActiveSuppliers } from '../Models/ActiveClasses';

@Injectable({
  providedIn: 'root'
})
export class InsuranceService {

  baseUrl = environment.baseUrl;
  backSystemUrl = environment.backSystemBaseUrl;
  //private results = new BehaviorSubject<any>(null);
  public showSpinner: BehaviorSubject<boolean> = new BehaviorSubject(false);
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }
  GetPlansAvailability(param: FormData): Observable<RootResponse | any> {
    return this.http.post<RootResponse | any>(this.baseUrl + '/TravelInsurance/GetPlansAvailability/', param)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  getAllPolicies(policyid: number): Observable<any> {
    return this.http.get(this.baseUrl+'/TravelInsurance/GetBookingPolicies/'+policyid);
  }

  ConfirmPlanPurchase(issuanceObj: TravelInsurancePlanPurchaseProperties): Observable<string | any> {
    return this.http.post<string | any>(this.baseUrl + '/TravelInsurance/ConfirmPlanPurchase/', issuanceObj, this.httpOptions)
      .pipe(map((data: any) => {
        //const parsedData = JSON.parse(data);
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetPolicyDetails(PNR: string): Observable<InsuranceIssuanceBaseData> {
    return this.http.get<string | any>(this.baseUrl+'/TravelInsurance/GetPolicyDetails/'+PNR).pipe(map((data: any) => { return data }), catchError(error => { return throwError(error); }))
  }
  EmailPlanQuote(emailObj: EmailItineraryProperties): Observable<string | any> {
    return this.http.post<string | any>(this.baseUrl + '/TravelInsurance/EmailPlanQuotation/', emailObj, this.httpOptions)
      .pipe(map((data: any) => {
        //const parsedData = JSON.parse(data);
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  InsertInsuranceIssuance(dbData: DBInsertProps): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/TravelInsurance/InsertInsuranceIssuance/', dbData, this.httpOptions)
      .pipe(map((data:any) => { return data }), catchError(error => { return throwError(error); }))
  }
  CancelInsurancePolicy(reqData: PurchaseResponse): Observable<string | any> {
    return this.http.post<string | any>(this.baseUrl + '/TravelInsurance/CancelPolicy/', reqData, this.httpOptions)
      .pipe(map((data: any) => { return data }), catchError(error => { return throwError(error); }))
  }
  InsertUniInsuranceDB(dbData: UnitedPassengersBaseProperties): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/TravelInsurance/InsertUniInsuranceDB/', dbData, this.httpOptions)
      .pipe(map((data: any) => { return data }), catchError(error => { return throwError(error); }))
  }
  GetPolicyDetailsUnited(PN: string): Observable<UnitedPassengersBaseProperties> {
    return this.http.get<UnitedPassengersBaseProperties>(this.baseUrl + '/TravelInsurance/GetPolicyDetailsUnited/' + PN).pipe(map((data: any) => { return data }), catchError(error => { return throwError(error); }))
  }

  GetTravelInsurancePlans(bookingObj): Observable<object> {
    return this.http.post<object>(this.baseUrl + '/FlightSearch/GetInsurancePlans', bookingObj, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)))
  }
  getCountrybyCityName(targetCity: string): Observable<string> {
    return this.http.get((this.baseUrl + '/TravelInsurance/GetCountryByCityName/' + targetCity), { responseType: 'text' })
      .pipe(
        map((data: any) => {
          return data;
        }), catchError(error => {
          return throwError(error);
        })
      )
  }

  CreateTravelInsuranceData(TIObj: TravelInsuranceDataProps): Observable<boolean> {
    return (this.http.post<boolean>(this.baseUrl + '/TravelInsurance/CreateTravelInsuranceData', TIObj, this.httpOptions))
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetALLCoveragesDetail(): Observable<GetALLCoveragesDetailResponse[]> {
    return this.http.get<GetALLCoveragesDetailResponse[]>(this.baseUrl + '/TravelInsurance/GetALLCoveragesDetail')
      .pipe(
        map((data: any) => {
          return data;
        }), catchError(error => {
          return throwError(error);
        })
      )
  }
  GetPackagesDetailByTravelPeriodWithCovid(obj: UnitedPassengersBaseProperties): Observable<GetPackagesDetailByTravelPeriodWithCovidResponse[]> {
    return this.http.post<GetPackagesDetailByTravelPeriodWithCovidResponse[]>(this.baseUrl + '/TravelInsurance/GetPackagesDetailByTravelPeriodWithCovid', obj, this.httpOptions).pipe(map((data: any) => {
      return data;
    }), (error) => {
      return error;
    });
  }
  getPackagesDetailBenefitsbyArea(obj: GetCoveragesDetailbyAreaRequest): Observable<GetCoveragesDetailByAreaResponse[]> {
    return this.http.post<GetCoveragesDetailByAreaResponse[]>(this.baseUrl + '/TravelInsurance/GetCoveragesDetailbyArea', obj, this.httpOptions).pipe(map((data: any) => {
      return data;
    }), (error) => {
      return error;
    });
  }

  GetCountryDetailbyArea(obj: GetCountryDetailbyAreaRequest): Observable<GetCountryDetailbyAreaResponse[]> {
    return this.http.post<GetCountryDetailbyAreaResponse[]>(this.baseUrl + '/TravelInsurance/GetCountryDetailbyArea', obj, this.httpOptions).pipe(map((data: any) => {
      return data;
    }), (error) => {
      return error;
    });
  }

  GenerateUWDocument(obj: UnitedPassengersBaseProperties): Observable<GenerateUWDocumentResponse[]> {
    return this.http.post<GenerateUWDocumentResponse[]>(this.baseUrl + '/TravelInsurance/GenerateUWDocument', obj, this.httpOptions).pipe(map((data: any) => {
      return data;
    }), (error) => {
      return error;
    });
  }

  GetRequestedUWDocumentData(obj: UnitedPassengersBaseProperties): Observable<GetRequestedUWDocumentDataResponse[]> {
    return this.http.post<GetRequestedUWDocumentDataResponse[]>(this.baseUrl + '/TravelInsurance/GetRequestedUWDocumentData', obj, this.httpOptions).pipe(map((data: any) => {
      return data;
    }), (error) => {
      return error;
    });
  }
  ProcessUWRequestData(obj: UnitedPassengersBaseProperties): Observable<ProcessUWRequestDataResponse[]> {
    return this.http.post<ProcessUWRequestDataResponse[]>(this.baseUrl + '/TravelInsurance/ProcessUWRequestData', obj, this.httpOptions).pipe(map((data: any) => {
      return data;
    }), (error) => {
      return error;
    });
  }
  CheckRightsInsurance(RightsObj): Observable<InsuranceRights> {
    return this.http.post<InsuranceRights>(this.baseUrl + '/TravelInsurance/CheckRightsInsurance/', RightsObj);
  }
  CheckSupplierOnOff(AgencyId: string): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/TravelInsurance/IsInsuranceSupplierOn/' + AgencyId);
  }
  //addPlanResults(results: any) {
  //  this.results.next(results);
  //}

  //getPlanResults() {
  //  return this.results.asObservable();
  //}

  //clearPlanResults() {
  //  this.results.next(null);
  //}
}
